import { createRouter , createWebHistory } from 'vue-router'

import Home from '../components/Home.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
     component: Home
  }
]

const router = createRouter({
history: createWebHistory('/api/examples/vue-responsive/index.html'),  routes
})




export default router
